import React from 'react';

import * as Styled from './price-display.style';

export type PriceDisplayProps = {
  amount: React.ReactNode;
  caption: React.ReactNode;
};

export const PriceDisplay: React.FC<PriceDisplayProps> = ({
  amount,
  caption,
}) => (
  <Styled.PriceBlock>
    <Styled.PriceAmount>{amount}</Styled.PriceAmount>
    <Styled.PriceCaption>{caption}</Styled.PriceCaption>
  </Styled.PriceBlock>
);
